/**
 * El motivo de un rechazo o una anulación, bajo el estado de una solicitud de
 * vacaciones o de permiso (#1490). Lo usan el ERP (Vacaciones) y el portal.
 */
export function MotivoDeLaDecision({ status, motivo }: { status: string; motivo?: string }) {
  if (!motivo || (status !== 'rejected' && status !== 'cancelled')) return null
  return (
    <div className="text-[11px] text-content-subtle mt-1 max-w-[16rem] whitespace-normal">
      Motivo: {motivo}
    </div>
  )
}
